import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border-2 border-foreground px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-2 border-black bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-2 border-black bg-status-error text-foreground hover:bg-status-error/80",
        outline: "text-foreground border-2 border-black",
        success:
          "border-2 border-black bg-status-success text-foreground hover:bg-status-success/80",
        warning:
          "border-2 border-black bg-status-warning text-foreground hover:bg-status-warning/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge }
